import React from "react";

export default function NotFound() {
	return (
		<div>
			<h1>Page not found</h1>
		</div>
	);
}
